import { memo, useState } from 'react';
import clsx from 'clsx';
import useMemoSelector from 'hooks/useMemoSelector';
import useImageNaturalSize from 'hooks/useImageNaturalSize';

import { deviceParams } from 'store/reselect';

import { useImageStyles } from './styles';
import ImageModal from './ImageModal';

const Image = ({ value, isAdView, isSingleColumn, className, columnCount }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { deviceType } = useMemoSelector(deviceParams());
  const { root } = useImageStyles({ deviceType, columnCount });
  const [imgRef, { width, height }] = useImageNaturalSize();

  return (
    <>
      <div
        className={clsx(root, className, {
          center: !isAdView && isSingleColumn,
        })}
      >
        {value.url && (
          <img
            ref={imgRef}
            width={width}
            height={height}
            src={value.url}
            alt={value.alt}
            title={value.title}
            onClick={() => setIsOpen(true)}
            style={{ cursor: 'zoom-in' }}
          />
        )}
      </div>
      {isOpen && <ImageModal value={value} onClose={() => setIsOpen(false)} />}
    </>
  );
};

export default memo(Image);
